import { getPartOfCurrentQueryString } from 'helpers/getPartOfCurrentQueryString';
import { QueryParams } from 'types/enums';

const addQueryStringTo = (url: string, isAllowed = true) => {
    const queryString = getPartOfCurrentQueryString({
        routerQueryString: window.location.search,
        queriesToExclude: [QueryParams.tab, QueryParams.page],
    });

    return isAllowed && queryString ? `${url}?${queryString}` : url;
};

export default addQueryStringTo;
